<div class="flex flex-col h-screen">
  <main class="flex-1 flex items-center justify-center w-full" [ngClass]="foreground ? 'foreground' : 'background'">
    <section class="h-full">
      <ng-content select="[menu]" />
    </section>

    <section class="flex flex-col h-full max-w-screen flex-1 overflow-hidden min-w-0">
      <div class="w-full">
        <ng-content select="[header]" />
      </div>

      <div
        class="flex-1"
        [class.mt-[110px]]="showHeader"
        [ngClass]="fullscreen ? 'p-0' : 'px-3 pb-3 lg:px-10'"
      >
        <div class="lg:mx-28">
          <ng-content select="router-outlet" />
        </div>
      </div>
    </section>
  </main>

  <footer [ngClass]="foreground ? 'foreground' : 'background'" class="flex w-full items-center justify-center pb-2 pt-5 text-lPrimary h-min">
    {{ version }}
  </footer> 
</div>
